// router 实例持有者：ViteSSG 在 client 启动回调中注入，供非组件模块（如 api/siteClient.ts）在登录态失效时跳转登录页。
// 独立成模块避免 main.ts ↔ siteClient 循环依赖。
import type { Router } from 'vue-router'

export const routerHolder: { instance: Router | null } = { instance: null }
